import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "toast__wrap" };
const _hoisted_2 = { class: "toast__info" };
const _hoisted_3 = {
    key: 0,
    class: "toast__icon"
};
const _hoisted_4 = { class: "toast__text" };
const _hoisted_5 = {
    key: 0,
    class: "toast__close"
};
const _hoisted_6 = { class: "btn__icon" };
import { StatusClassNames } from "../types/StatusClassNames";
import Icon from "./Icon.vue";
import Sprite from "./Sprite.vue";
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { onTransitionEnd } from "../utils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Toast',
    props: {
        active: { type: Boolean, default: true },
        autoHide: Boolean,
        bottom: Boolean,
        noClose: Boolean,
        narrow: Boolean,
        icon: { type: String },
        progress: Boolean,
        quick: Boolean,
    },
    emits: ['close'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const progressElement = ref();
        const isActive = ref(false);
        const toast = ref();
        const reset = ref(false);
        const closing = ref(false);
        const progressClasses = computed(() => ({
            'toast__progress--running': props.autoHide,
            'toast__progress--quick': props.quick,
            'toast__progress--invisible': !props.progress,
            'toast__progress--narrow': !props.narrow,
            'toast__progress--reset': reset.value,
        }));
        function close() {
            isActive.value = false;
            closing.value = true;
            onTransitionEnd(toast.value, () => {
                if (closing.value) {
                    emit('close');
                }
                else {
                    isActive.value = true;
                }
            });
        }
        onMounted(() => {
            var _a;
            (_a = progressElement.value) === null || _a === void 0 ? void 0 : _a.addEventListener('animationend', close);
            if (props.active) {
                setTimeout(() => isActive.value = true);
            }
        });
        onUnmounted(() => {
            var _a;
            (_a = progressElement.value) === null || _a === void 0 ? void 0 : _a.removeEventListener('animationend', close);
        });
        watch(() => props.autoHide, (value, oldValue) => {
            closing.value = false;
            isActive.value = true;
            if (!value && oldValue) {
                reset.value = true;
                setTimeout(() => reset.value = false);
            }
        });
        watch(() => props.active, (value, oldValue) => {
            if (value && !oldValue) {
                isActive.value = true;
                closing.value = false;
            }
            else if (!value && oldValue) {
                close();
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["toast toast--primary", { [_unref(StatusClassNames).active]: isActive.value, 'toast--bottom': __props.bottom }]),
                ref_key: "toast",
                ref: toast
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        (__props.icon || _ctx.$slots.icon)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _renderSlot(_ctx.$slots, "icon", {}, () => [
                                    _createVNode(Sprite, {
                                        name: __props.icon,
                                        size: 32
                                    }, null, 8 /* PROPS */, ["name"])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true),
                        _cache[0] || (_cache[0] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_4, [
                            _renderSlot(_ctx.$slots, "default")
                        ])
                    ]),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    (!__props.noClose)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn--4 btn--m btn--primary btn--icon",
                                onClick: _withModifiers(close, ["prevent", "stop"])
                            }, [
                                _createElementVNode("span", _hoisted_6, [
                                    _createVNode(Icon, { name: "cross" })
                                ])
                            ])
                        ]))
                        : _createCommentVNode("v-if", true),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    _createElementVNode("div", {
                        class: _normalizeClass(["toast__progress", progressClasses.value]),
                        ref_key: "progressElement",
                        ref: progressElement
                    }, null, 2 /* CLASS */)
                ])
            ], 2 /* CLASS */));
        };
    }
});
